import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "table"
}
const _hoisted_2 = { style: {"width":"150px"} }
const _hoisted_3 = { style: {"width":"320px"} }
const _hoisted_4 = { class: "text-right" }

import {computed} from 'vue';
import {
    CustomShortcutInterface, CustomShortcutTypeId,
    OperatorApplicationConfigInstance,
} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import ShortcutConfigInput from "~/operatorApplication/vue/config/ShortcutConfigInput.vue";
import {ShortcutsList} from "~/operatorApplication/ts/service/shortcuts/ShortcutsList";
import MyIconButton from "~/cabinet/vue/interface/button/MyIconButton.vue";
import ObjectHelper from "~/ts/library/ObjectHelper";
import {getCustomShortcutTypes} from "~/operatorApplication/ts/service/shortcuts/CustomShortcutTypes";
import NonFreeConfigOption from "~/operatorApplication/vue/config/NonFreeConfigOption.vue";
import {__} from "~/ts/library/Translate";



const __default__ = {
    name: "OperatorApplicationConfigShortcuts"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let configuration = computed(() => {
    return OperatorApplicationConfigInstance;
});

let shortcuts = computed(() => {
    return ShortcutsList.list;
});

function isShortcutAlreadyUsed(shortcut: string) {
    return configuration.value.isShortcutUsed(shortcut);
}

function getValue(action: string) {
    return configuration.value.getShortcut(action);
}

function getMessageTemplates(site: OperatorApplicationApi.OperatorGetParamsSiteOpenApiModel) {
    return OperatorAccountStore.getMessageTemplatesBySite(site.id)
}

function setValue(action: string, shortcut: string) {
    let previousShortcut = configuration.value.getShortcut(action);
    configuration.value.setShortcut(action, null);
    let isUsed = isShortcutAlreadyUsed(shortcut) && configuration.value.getShortcut(action) != shortcut;
    configuration.value.setShortcut(
        action,
        isUsed ? previousShortcut : shortcut
    );

}

let customShortcutTypes = computed(() => getCustomShortcutTypes());
let customShortcutTypesDictionary = computed(() => ObjectHelper.dictionaryFromArray(customShortcutTypes.value));


function setCustomShortcutKeys(key: number, shortcut: string) {
    let previousShortcut: string;
    setCustomShortcut(item => {
        previousShortcut = item.shortcut;
        item.shortcut = null;
    }, key);

    setCustomShortcut(item => {
        item.shortcut = isShortcutAlreadyUsed(shortcut) ? previousShortcut : shortcut;
    }, key);
}

function setCustomShortcutTypeId(key: number, typeId: CustomShortcutTypeId) {
    setCustomShortcut(item => {
        item.typeId = typeId;
        item.payload = null;
    }, key);
}

function setCustomShortcutPayload(key: number, payload: string) {
    setCustomShortcut(item => item.payload = payload, key);
}

function setCustomShortcut(callback?: (template: CustomShortcutInterface) => void, key?: number) {
    let customShortcut: CustomShortcutInterface;
    let list = configuration.value.customShortcuts;
    if (typeof key == "number") {
        customShortcut = list[key];
    }
    if (!customShortcut) {
        key = null;
        customShortcut = {
            typeId: null,
            payload: null,
            shortcut: null
        };
    }
    if (callback) {
        callback(customShortcut);
    }
    if (typeof key == "number") {
        list[key] = customShortcut;
    } else {
        list.push(customShortcut);
    }
    configuration.value.customShortcuts = list;
}

function deleteTemplate(key: number) {
    let list = configuration.value.customShortcuts;
    list.splice(key, 1);
    configuration.value.customShortcuts = list;
}

function addTemplate() {
    setCustomShortcut();
}


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", null, _toDisplayString(_unref(__)("Основные клавиши")), 1),
    (!_unref(OperatorAccountStore).hasNonFreeSites)
      ? (_openBlock(), _createBlock(NonFreeConfigOption, {
          key: 0,
          class: "mb-4",
          block: ""
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, {
      "label-position": "left",
      "label-width": "180px"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shortcuts), (item, action) => {
          return (_openBlock(), _createBlock(_component_el_form_item, {
            key: action,
            label: item.descr
          }, {
            default: _withCtx(() => [
              _createVNode(ShortcutConfigInput, {
                "model-value": getValue(action),
                "onUpdate:modelValue": ($event: any) => (setValue(action, $event))
              }, null, 8, ["model-value", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("h2", null, _toDisplayString(_unref(__)("Пользовательские клавиши")), 1),
    (_unref(configuration).customShortcuts.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_2, _toDisplayString(_unref(__)("Сочетание клавиш")), 1),
              _createElementVNode("th", _hoisted_3, _toDisplayString(_unref(__)("Тип действия")), 1),
              _cache[0] || (_cache[0] = _createElementVNode("th", null, null, -1)),
              _cache[1] || (_cache[1] = _createElementVNode("th", { style: {"width":"3em"} }, null, -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configuration).customShortcuts, (item, key) => {
              return (_openBlock(), _createElementBlock("tr", { key: key }, [
                _createElementVNode("td", null, [
                  _createVNode(ShortcutConfigInput, {
                    "model-value": item.shortcut,
                    "onUpdate:modelValue": ($event: any) => (setCustomShortcutKeys(key, $event))
                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_el_select, {
                    "model-value": item.typeId,
                    "onUpdate:modelValue": ($event: any) => (setCustomShortcutTypeId(key, $event)),
                    "fallback-placements": ['bottom-start'],
                    placement: "top",
                    class: "w-100",
                    placeholder: _unref(__)('Выберите тип')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customShortcutTypes), (type) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: type.id,
                          value: type.id,
                          label: type.descr
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["model-value", "onUpdate:modelValue", "placeholder"])
                ]),
                _createElementVNode("td", null, [
                  (_unref(customShortcutTypesDictionary)[item.typeId])
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        "model-value": item.payload,
                        "onUpdate:modelValue": ($event: any) => (setCustomShortcutPayload(key, $event)),
                        class: "w-100",
                        placeholder: _unref(__)('Не выбрано'),
                        "fallback-placements": ['bottom-start'],
                        placement: "top",
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customShortcutTypesDictionary)[item.typeId].payloadGroups, (group) => {
                            return (_openBlock(), _createBlock(_component_el_option_group, {
                              key: group.id,
                              label: group.descr
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (option) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: option.id,
                                    label: option.descr,
                                    value: option.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["model-value", "onUpdate:modelValue", "placeholder"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_4, [
                  _createVNode(MyIconButton, {
                    delete: "",
                    onClick: ($event: any) => (deleteTemplate(key))
                  }, null, 8, ["onClick"])
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_button, {
      type: "primary",
      plain: "",
      onClick: addTemplate
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(__)('Добавить')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})